import { useQuery } from "react-query";
import { getRehirables } from "../../../../../actions/Employees";

export const useGetRehirable = () => {
  return useQuery("GetRehirables", getRehirables, {
    refetchOnWindowFocus: false,
  });
};
